export function performOnNextFrame(callback) {
    // Wait for next frame to measure visual changes (https://nolanlawson.com/2018/09/25/accurately-measuring-layout-on-the-web/)
    return requestAnimationFrame(function () { return setTimeout(callback, 0); });
}
//# sourceMappingURL=performOnNextFrame.js.map